import React from 'react';
import BaseComponent from './BaseContainer';
import { withApollo, compose, graphql } from 'react-apollo';
import { Redirect } from 'react-router';
import getLanguages from '../apollo/graphql/getLanguages';
import getCategories from '../apollo/graphql/category/getCategories';
import getCategory from '../apollo/graphql/category/get';
import updateCategory from '../apollo/graphql/category/update';
import createCategory from '../apollo/graphql/category/create';
import deleteCategory from '../apollo/graphql/category/delete';
import CategoryForm from '../components/form/Category';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
  createTranslationsObjectOld,
} from '../helpers/translation';

class CategoryContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
      },
      obj: {
        translations: createTranslationsObjectOld({
          label: '',
        }),
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getCategory,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getCategory.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getCategory.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...convertGraphQlToObject(data.getCategory),
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let newState = {
      status: { ...this.state.status },
    };
    newState.status.loading = false;
    this.setState(newState);
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (type === 'checkbox') {
      newState.obj[data.id] = data.checked;
    } else if (data === parseInt(data, 10)) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = convertObjetToGraphQlVariables(this.state.obj);
    this.state.status.isNew
      ? this.props
          .createCategory({
            variables: {
              ...obj,
            },
          })
          .then((data) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: `Création effectuée le ${new Date(
                  Date.now(),
                ).toLocaleString()}`,
                isNew: false,
              },
              obj: {
                ...this.state.obj,
                id: data.data.createCategory.id,
              },
              redirect: true,
            });
          })
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
                isNew: true,
              },
            });
          })
      : this.props
          .updateCategory({
            variables: {
              ...obj,
            },
          })
          .then(this.setState({ redirect: true }))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
  }

  handleDelete(event, data) {
    event.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteCategory({ variables: { id: this.state.obj.id } })
          .then(this.setState({ redirect: true }))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/categories" />;
    }

    return (
      <CategoryForm
        obj={this.state.obj}
        languages={this.props.getLanguages}
        categories={this.props.getCategories}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
      />
    );
  }
}

const CategoryContainerEnhanced = compose(
  graphql(getLanguages, { name: 'getLanguages' }),
  graphql(getCategories, { name: 'getCategories' }),
  graphql(updateCategory, { name: 'updateCategory' }),
  graphql(createCategory, { name: 'createCategory' }),
  graphql(deleteCategory, {
    name: 'deleteCategory',
    options: {
      update: (proxy, { data }) => {
        const categories = proxy.readQuery({ query: getCategories });
        categories.getCategories = categories.getCategories.filter(
          (obj) => obj.id !== data.deleteCategory.id,
        );
        proxy.writeQuery({ query: getCategories, data: categories });
      },
    },
  }),
)(CategoryContainer);

export default withApollo(CategoryContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/CategoryContainer.js